import { render, staticRenderFns } from "./quickEntityAddWidget.vue?vue&type=template&id=1cf52ada"
import script from "./quickEntityAddWidget.vue?vue&type=script&lang=js"
export * from "./quickEntityAddWidget.vue?vue&type=script&lang=js"
import style0 from "./quickEntityAddWidget.vue?vue&type=style&index=0&id=1cf52ada&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports